import {Version, DocumentVersionEventAction} from 'notebook/version-history/VersionHistoryTypes';

const DATA_SUBMISSION_EVENT_ACTIONS: Array<DocumentVersionEventAction> = [
  DocumentVersionEventAction.STRUCTURED_TABLE_SUBMIT,
];

/**
 * This function returns the first occurrence of a `Version` in the array that is a data submission event.
 * @param versions array of versions ordered from most recent to oldest
 * @returns the last version that had a data submission event occur
 */
export const getLastDataSubmissionVersion = (versions: Array<Version>): Version | null =>
  versions.find((version) =>
    version.documentVersionEvent?.action
      ? DATA_SUBMISSION_EVENT_ACTIONS.includes(version.documentVersionEvent?.action)
      : false
  ) ?? null;
